import React, { useState } from "react"
import { PickerOverlay } from "filestack-react"

import styles from "./CloudUpload.module.css"
import { isMobile } from "app/assets/javascripts/utils/breakpoints"
import scribdAuthorize from "app/assets/javascripts/scribd/scribd_oauth"

import { FILE_TYPES } from "./constants"
import { getUploadBucket, logUploadFlowEvent, verifyFiles, t } from "frontend/utils"

export const getPickerOptions = (onFileSelection, onClose) => {
  return {
    exposeOriginalFile: true,
    onUploadDone: (data) => {
      onFileSelection(data.filesUploaded)
    },
    onClose,
    accept: FILE_TYPES,
    fromSources: ["googledrive", "dropbox", "box", "onedrive", "gmail", "url"],
    maxFiles: isMobile() ? 3 : 30,
    storeTo: {
      container: getUploadBucket(),
    },
  }
}

const CloudUpload = ({ onFileSelection, setError }) => {
  const [showPicker, setShowPicker] = useState(false)
  const handleOpenPicker = (e) => {
    if (!window.upload_config.logged_in) {
      return scribdAuthorize({ from_source: window.location.pathname })
    }
    e.preventDefault()
    logUploadFlowEvent("filepicker_click")

    setError("")
    setShowPicker(true)
  }

  const handleFileSelection = (uploadedFiles) => {
    setShowPicker(false)
    setError("")

    logUploadFlowEvent("files_selected", {
      number_of_files: uploadedFiles.length,
      selection_method: "cloud",
    })

    const files = uploadedFiles.map(({ filename, key, uploadId, size, source }) => {
      logUploadFlowEvent("file_queued", { file_source: source })

      return { filename, key, uploadId, size }
    })
    try {
      verifyFiles(files)
    } catch (e) {
      logUploadFlowEvent("validation_error")

      setError(e.message)
      return
    }

    logUploadFlowEvent("chooser_complete")

    onFileSelection(files)
  }

  const handleClose = () => {
    logUploadFlowEvent("chooser_cancel")

    setShowPicker(false)
  }

  const options = getPickerOptions(handleFileSelection, handleClose)

  return (
    <div className={styles.cloudUpload}>
      <p className={styles.cloudCta}>{t("upload.file_selection.cloud_cta")}</p>
      <a
        href="#"
        onClick={handleOpenPicker}
        className={styles.cloudUploadButton}
        aria-label={t("upload.file_selection.cloud_label")}
      >
        <div className={styles.cloudUploadSprite} />
      </a>
      {showPicker && (
        <PickerOverlay
          pickerOptions={options}
          apikey={window.upload_config.filepicker.api_key}
          clientOptions={{
            security: {
              policy: window.upload_config.filepicker.policy,
              signature: window.upload_config.filepicker.signature,
            },
          }}
        />
      )}
    </div>
  )
}

CloudUpload.defaultProps = {
  onFileSelection: () => {},
  setError: () => {},
}

export default CloudUpload
